import React, { Component } from "react";
import Modal from "@acadia-ui/modal";
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import "./modal.scss";
import ModalHelpers from "./ModalHelpers";

const formEl = "toggleBudgetLockModal";

class LockBudgetConfirmationModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lock: true
		};
	}

	componentDidMount() {
		this.props.lockBudgetModal(this);
	}

	componentWillUnmount() {
		this.props.lockBudgetModal(undefined);
	}

	/* Needed for all Modals */
	triggerOpenClose = (event, lock) => {
		this.setState({ lock });
		ModalHelpers.openCloseNoData(event, this.updateModalState, this.state);
	};

	updateModalState = () => {
		this.state.open ? Modal.hide(formEl) : Modal.show(formEl);
		this.setState({ open: !this.state.open });
	};

	handleSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.props.onSubmit();
		this.triggerOpenClose();
	};

	render() {
		return (
			<Modal
				id={formEl}
				heading={this.state.lock ? "Lock Budget" : "Unlock Budget"}
				onRequestClose={this.triggerOpenClose}
				actionSetProps={{
					actionsRight: (
						<>
							<Button
								display={BUTTON_DISPLAY.SECONDARY}
								onClick={(e) => {
									e.stopPropagation();
									this.triggerOpenClose();
								}}
								data-tracking-id-alt={this.state.lock ? "cancel-lock-budget" : "cancel-unlock-budget"}
							>
								Cancel
							</Button>
							<Button onClick={this.handleSubmit} data-tracking-id-alt={this.state.lock ? "confirm-lock-budget" : "confirm-unlock-budget"}>
								{this.state.lock ? "Lock" : "Unlock"}
							</Button>
						</>
					)
				}}
				onClick={() => {}}
			>
				<p className="text" style={{ maxWidth: 600 }}>
					{this.state.lock
						? "Locking the budget will not allow for edits to be made to rate type, rate, units, cost or campaign financial settings. Budget and financial settings entered in Prisma will override the existing data in Placement Manager upon push."
						: "Unlocking the budget will allow for any edits made in Placement Manager to be pushed to Prisma. Budget and financial settings entered in Placement Manager will override the existing amounts in Prisma."}
				</p>
			</Modal>
		);
	}
}

export default LockBudgetConfirmationModal;
